<template>
  <div>
    <h3>Spec</h3>
    <div class="h4 py-5">
      Spec會顯示於產品頁、產品比較 ; 同SubCategory的產品將同步Spec欄位。
    </div>

    <!-- add spec title -->
    <div class="d-flex pa-5 brand-100">
      <label for="filterTitleAdd"><h4 class="mr-5">Spec Title</h4></label>
      <div class="d-flex my-n2 flex-grow-1">
        <div class="form-input-group flex-grow-1">
          <input
            type="text"
            id="filterTitleAdd"
            placeholder="請輸入Spec標題"
            style="background: white;"
            v-model="tempSpecTitle"
          />
        </div>
        <div class="ml-5">
          <button class="btn btn-primary w-90px" @click="addItem">
            新增
          </button>
        </div>
      </div>
    </div>

    <!-- items -->
    <div
      class="form-item d-flex pa-5"
      v-for="(item, i) in specs"
      :key="i"
    >
      <label class="d-flex flex-grow-1">
        <h4 class="mr-5">Spec Title</h4>
        <div class="form-input-group flex-grow-1 my-n2">
          <input
            type="text"
            placeholder="請輸入Sec標題"
            style="background: white;"
            v-model="item.title"
          />
        </div>
      </label>
      <div class="ml-5 my-n2">
        <button class="btn square mr-10px" @click="deleteItem(item)">
          <v-icon>delete</v-icon>
        </button>
        <button class="btn square mr-10px" @click="downItem(item, i)">
          <v-icon>arrow_downward</v-icon>
        </button>
        <button class="btn square" @click="upItem(item, i)">
          <v-icon>arrow_upward</v-icon>
        </button>
      </div>
    </div>
    <div
      class="form-item d-flex pa-5"
    >
      <label class="d-flex flex-grow-1">
        <h4 class="mr-5">Spec Title</h4>
        <div class="form-input-group flex-grow-1 my-n2">
          <input
            type="text"
            placeholder="備註"
            :disabled="true"
          />
        </div>
      </label>
      <div class="ml-5 my-n2"></div>
    </div>
  </div>
</template>

<script>
import { mapState, mapGetters } from 'vuex';

export default {
  data: () => ({
    tempSpecTitle: '',
  }),
  computed: {
    ...mapState('subcategory', [
      'subcategory',
    ]),
    ...mapGetters('subcategory', [
      'specs',
    ]),
  },
  methods: {
    addItem() {
      if (this.tempSpecTitle.trim() === '') {
        return;
      }

      const template = {
        id: null,
        title: this.tempSpecTitle.trim(),
        is_customized: 0,
        is_filter: 0,
      };

      this.subcategory.specs.push(template);
      this.tempSpecTitle = '';
    },
    deleteItem(item) {
      const index = this.subcategory.specs.map((option) => option.id).indexOf(item.id);
      this.subcategory.specs.splice(index, 1);
    },
    downItem(item, i) {
      // if i is last, then item become the first index
      if (i === this.subcategory.specs.length - 1) {
        this.subcategory.specs.splice(i, 1);
        this.subcategory.specs.unshift(item);
        return;
      }
      // item become next index
      this.subcategory.specs.splice(i, 1);
      this.subcategory.specs.splice(i + 1, 0, item);
    },
    upItem(item, i) {
      // if i = 0, then item go to the last one
      if (i === 0) {
        this.subcategory.specs.splice(i, 1);
        this.subcategory.specs.push(item);
        return;
      }
      // item become previous index
      this.subcategory.specs.splice(i, 1);
      this.subcategory.specs.splice(i - 1, 0, item);
    },
  },
};
</script>

<style></style>
